<template>
  <div class="notice-drawer-content">
    <pb-drawer :with-header="false" custom-class="notice-drawer" width="500" :visible.sync="show" :append-to-body="true">
      <Header :title="$t('Gattaran_MSGCenter__mzAm' /**消息中心*/)" @close="show = false" />
      <section ref="noticeContent" class="notice-content">
        <pb-tabs v-model="data.activeName" @tab-click="handleClick">
          <pb-tab-pane v-for="item in data.tabList" :key="item.value" :label="item.label" :name="item.value.toString()">
            <div v-if="list.length > 0" v-loading="data.reloading" class="notice-drawer-content-list" element-loading-text="loading..." @scroll="linterScroll" @wheel="onWheel">
              <transition>
                <div v-show="data.reloading" class="notice-drawer-re-loading-more" />
              </transition>
              <div ref="noticeRealRef">
                <NotificationCard
                  v-for="(it, ind) in list"
                  :key="ind"
                  v-laze-loading="{ ...it, that }"
                  :title="it.title"
                  :content="it.content"
                  :module="it.module"
                  :datetime="it.sendTime"
                  :images="it.images"
                  :content-images="it.contentImages"
                  :link="it.link"
                  :link-text="it.linkText"
                  :un-read="+it.status === ReadStatus.UN_READ"
                  :msg-type="msgTypeFilter(it.msgType)"
                  @click="clickCard"
                />
              </div>
              <div v-show="list.length > 0 && data.isMore" v-loading="data.loadingMore" :element-loading-text="$t('Gattaran_MSGCenter__PuUe' /** 正在加载中...*/)" class="notice-drawer-loading-more" />
              <div v-show="list.length > 0 && !data.isMore" class="notice-drawer-no-more">
                {{ $t('Gattaran_MSGCenter__chmB' /** 无更多消息*/) }}
              </div>
            </div>
            <div v-if="list.length === 0 && !data.isMore" class="notice-drawer-content-empty">
              <img :src="require('./static/empty.svg')" alt="" />
              <p>{{ $t('Gattaran_MSGCenter__wEBm' /** 暂无消息*/) }}</p>
            </div>
            <div v-show="list.length === 0 && data.isMore" class="notice-drawer-content-loading">
              {{ $t('Gattaran_MSGCenter__PuUe' /** 正在加载中*/) }}
            </div>
          </pb-tab-pane>
        </pb-tabs>
      </section>
      <div v-if="list.length > 0" class="notice-drawer-bottom">
        <span @click="putMsgReadHandle">{{ $t('Gattaran_MSGCenter__oHtl' /**全部已读*/) }}</span>
      </div>
    </pb-drawer>
  </div>
</template>

<script>
import Header from './components/Header';
import NotificationCard from './components/NotificationCard';
import { getCurrentInstance, reactive, ref, watchEffect } from 'vue';
import { getList, getMsgTypeList, putMsgRead } from './services';
import { debounce } from './utils/utils';
import { ReadStatus } from '@/config/constants';

export default {
  name: 'MessageCenterList',
  components: {
    Header,
    NotificationCard,
  },
  directives: {
    lazeLoading: {
      inserted(el, val) {
        const that = val.value.that;
        const lazy = new IntersectionObserver((obj) => {
          if (obj[0].isIntersecting) {
            const { status, messageId } = val.value;
            if (+status === ReadStatus.UN_READ) {
              that.readList.add(messageId);
              that.putReadStatus();
            }
            // 清除监听
            lazy.unobserve(el);
          }
        });
        lazy.observe(el);
      },
    },
  },
  setup() {
    const noticeRealRef = ref(null);
    const readList = ref(new Set());
    const { proxy } = getCurrentInstance();
    const $t = proxy.$root.$t.bind(proxy.$root);
    const allType = {
      label: $t('Gattaran_MSGCenter__HxEk' /** 全部 */),
      value: '0',
      children: [],
    };
    const noticeContent = ref(null);
    const show = ref(false);
    const list = ref([]);
    const tabInd = ref(0);
    const noticeScrollTop = ref(0);
    const data = reactive({
      isNeedReloading: false,
      drawer: false,
      activeName: '0',
      tabList: [],
      msgIds: [],
      loadingMore: false,
      page: 1,
      pageSize: 10,
      reloading: false,
      reloadingStyleHeight: 0,
      isMore: true, // 是否有更多数据
    });
    // 初始化参数
    const initParams = () => {
      data.isMore = true;
      data.page = 1;
      // data.activeName = 0
      list.value = [];
    };
    // 列表更新已读
    const setListIsRead = (ids) => {
      // 部分更新
      if (ids && ids.length > 0) {
        ids.forEach((i) => {
          const ind = list.value.findIndex((l) => l.messageId === i);
          if (ind !== -1) {
            list.value[ind].status = ReadStatus.IS_READ;
          }
        });
      } else {
        // 全更新
        list.value.forEach((i) => {
          i.status = ReadStatus.IS_READ;
        });
      }
    };
    // 批量读取信息
    // 三秒内不触发会批量更新已读状态
    const putReadStatus = debounce(async () => {
      const ids = [...readList.value];
      if (ids && ids.length > 0) {
        await putMsgRead({ isAll: 0, msgIds: ids });
        setListIsRead(ids);
        readList.value.clear();
      }
    }, 3000);
    // 获取类型列表
    const getTypes = async () => {
      // const types = await getMsgTypeList();
      // data.tabList = [allType, ...types];
      // 设计变更：仅展示全部消息
      data.tabList = [allType];
    };
    // 获取消息列表
    const getMsgList = async (params = {}) => {
      if (!data.isMore) {
        return {};
      }
      try {
        const listRes = await getList({
          page: data.page,
          pageSize: data.pageSize,
          msgType: +data.activeName ? data.activeName.toString() : '',
          ...params,
        });
        const ids = [];
        // listRes.lists.unshift({
        //   messageId: '16138361547910021213',
        //   uid: 'wangbingyang',
        //   msgType: '1,1001',
        //   status: 2,
        //   msgChannel: 'Gattaran消息中心',
        //   module: '商机&商家',
        //   country: 'MX',
        //   sendTime: '2023-01-13 03:50 UTC-3',
        //   readTime: '',
        //   msgTitle: 'sim测试老流程09',
        //   msgContent:
        //     '{"default":{"title":"sim测试老流程09","content":"sim测试老流程09","images":[{"urlHttps":"https://img0.didiglobal.com/static/soda_public/do1_GZGZz5zkjwveIYDMbygA","url":"http://img0.didiglobal.com/static/soda_public/do1_GZGZz5zkjwveIYDMbygA","key":"do1_GZGZz5zkjwveIYDMbygA","filename":"IMG_7480.JPG"}],"contentImages":[{"urlHttps":"https://img0.didiglobal.com/static/soda_public/do1_QLc2uKz1a9V7tMKR8U6a","url":"http://img0.didiglobal.com/static/soda_public/do1_QLc2uKz1a9V7tMKR8U6a","key":"do1_QLc2uKz1a9V7tMKR8U6a","filename":"IMG_7480.JPG"}],"link":"http://i18n.intra.didiglobal.com/product/view/12717","linkText":"sim测试老流程09"}}',
        //   templateId: 0,
        // });
        const lists = (listRes.lists || []).map((i) => {
          const { msgContent, ...other } = i;
          if (other.messageId && +other.status === 1) {
            ids.push(other.messageId);
          }
          return {
            ...other,
            ...msgContent,
          };
        });
        data.loadingMore = false;
        // data.reloading = false
        setTimeout(() => {
          data.reloading = false;
          flag = false;
        }, 500);
        // data.reloadingStyleHeight = 0
        list.value = [...list.value, ...lists];
        if (lists.length < data.pageSize) {
          // 说明没有更多数据了
          data.isMore = false;
        }
        return {
          ids,
        };
      } catch (e) {
        console.error(e);
        data.isMore = false;
        setTimeout(() => {
          data.reloading = false;
          flag = false;
        }, 500);
        data.isMore = true;
        return {
          ids: [],
        };
      } finally {
        data.reloading = false;
        setTimeout(() => {
          flag = false;
        }, 500);
      }
    };
    // 展示的时候自动获取列表，并已读
    watchEffect(async () => {
      if (show.value) {
        try {
          initParams();
          await getTypes();
          await getMsgList();
        } catch (e) {
          console.error(e);
        }
      }
    });
    let timer = null;
    let flag = true;
    return {
      readList,
      putReadStatus,
      ReadStatus,
      noticeRealRef,
      show,
      data,
      async handleClick(value) {
        try {
          data.reloadingStyleHeight = 0;
          list.value = [];
          data.page = 1;
          data.isMore = true;
          data.activeName = value.name;
          tabInd.value = value.index;
          await getMsgList();
        } catch (e) {
          console.error(e);
        }
      },
      async putMsgReadHandle() {
        try {
          await putMsgRead({ isAll: 1 });
          setListIsRead();
        } catch (e) {
          console.error(e);
        }
      },
      list,
      noticeContent,
      clickCard(e) {},
      // 未实现，当前改成自动修改状态。不需要刷新。
      async onWheel(e) {
        if (noticeScrollTop.value === 0) {
          // const offsetTop = noticeRealRef.value[tabInd.value].offsetTop
          // reloadingStyle
          if (e.wheelDelta > 0) {
            timer = setTimeout(async () => {
              if (flag) {
                // flag = false
                // data.page = 1
                // list.value = []
                // data.loadingMore = true
                // const { ids } = await getMsgList()
                // if (ids && ids.length > 0) {
                //   await putMsgRead({ isAll: 0, msgIds: ids })
                // }
              }
              clearTimeout(timer);
            }, 600);
          }
        }
      },
      msgTypeFilter(str) {
        // 处理 一级消息类型 二级消息类型，当前gtr只需取一级消息类型。
        // '1,1001' , '1'
        return +str.split(',')[0] || 1;
      },
      async linterScroll(e) {
        let scrollTop = e.target.scrollTop;
        let clientHeight = e.target.clientHeight;
        let scrollHeight = e.target.scrollHeight;
        // 打印数值
        // console.table([
        //   {
        //     label: '距顶部',
        //     value: scrollTop,
        //   },
        //   {
        //     label: '可视区高度',
        //     value: clientHeight,
        //   },
        //   {
        //     label: '滚动条总高度',
        //     value: scrollHeight,
        //   },
        //   {
        //     label: '距顶部 + 可视区高度',
        //     value: scrollTop + clientHeight,
        //   },
        // ])
        if (scrollHeight - (scrollTop + clientHeight) < 1) {
          try {
            data.loadingMore = true;
            data.page++;
            await getMsgList();
          } catch (e) {
            console.log(e);
          }
        }
        noticeScrollTop.value = scrollTop;
        if (scrollTop === 0) {
          // data.page = 0
          // flag = true
          // data.reloading = true
          // console.log(noticeRealRef.value[tabInd.value].offsetTop)
        }
        // else {
        //   data.reloading = false
        //   flag = true
        // }
        if (scrollTop > 70) {
          data.reloading = false;
          flag = true;
        }
      },
    };
  },
  data() {
    return {
      that: this,
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.notice-drawer) {
  width: 480px !important;
  .pb-loading-mask {
    background: none;
  }
  .pb-tabs__nav-wrap::after {
    background: none;
  }
  .pb-drawer__body {
    padding: 0;
  }
  .notice-content {
    width: 100%;
    height: calc(100% - 56px - 64px);
    //padding: 8px 16px;
    background: #f8f8fa;
  }

  .notice-drawer-content-list {
    position: relative;
    width: 100%;
    height: calc(100vh - 56px - 64px - 21px);
    overflow-y: scroll;
  }

  .notice-drawer-content-list::-webkit-scrollbar {
    /*display: none*/
    /*right: -4px;*/
    width: 6px; /* 滚动条宽度， width：对应竖滚动条的宽度  height：对应横滚动条的高度*/
    height: 4px;
  }

  .notice-drawer-content-list::-webkit-scrollbar-thumb {
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  }

  .notice-drawer-content-list::after {
    background-color: #fff !important;
  }

  .notice-drawer-content-loading {
    background: none;
    height: calc(100vh - 106px - 64px - 4px);
    font-size: 14px;
    color: #8d9099;
    text-align: center;
    line-height: calc(100vh - 106px - 64px - 4px);
    font-weight: normal;
  }

  .notice-drawer-content-empty {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    /*height: calc(100vh - 64px - 58px);*/
    font-size: 14px;
    color: #8d9099;
    text-align: center;
    padding-top: calc(50vh - 140px);
    font-weight: normal;
  }

  .notice-drawer-bottom {
    width: 100%;
    height: 64px;
    line-height: 64px;
    border-top: 1px solid #e9eaee;
    font-size: 14px;
    color: #f76a31;
    font-weight: normal;
    text-align: right;
    padding-right: 32px;
  }

  .notice-drawer-bottom span {
    cursor: pointer;
  }

  .notice-drawer-loading-more {
    background: none;
    width: 100%;
    /*margin: 10px 0;*/
    height: 74px;
  }

  .pb-loading-spinner .circular {
    width: 24px !important;
    height: 24px !important;
  }

  .pb-loading-text {
    /*color: #030405;;*/
    font-size: 14px;
  }

  .pb-tabs__item {
    padding: 0 8px !important;
    font-family: DiDiSansPro, SF Pro Text, PingFang SC, PingFang TC, Meiryo, Microsoft Sans Serif, Microsoft YaHei, Microsoft JhengHei, Helvetica Neue, Helvetica, Arial, Sans-serif;
    /*font-family: DiDiSans-Pro-Medium;*/
  }

  //.pb-tabs__item:not(.is-active) {
  //  color: #8D9099;
  //}
  //
  //.pb-tabs__item.is-active {
  //  color: #282B33;
  //}
  //
  //.pb-tabs__active-bar {
  //  width: 100%;
  //  /*transform: translate(0) !important;*/
  //  background-color: #282B33;
  //}

  .notice-drawer-no-more {
    box-sizing: border-box;
    font-size: 14px;
    color: #8d9099;
    text-align: center;
    padding-top: 20px;
    height: 74px;
    font-weight: 400;
  }

  .notice-drawer-re-loading-more {
    width: 100%;
    height: 50px;
  }

  .v-enter-active,
  .v-leave-active {
    transition: all 0.6s ease-in;
  }

  .v-enter,
  .v-leave-to {
    opacity: 0;
    height: 0;
  }

  .v-enter-to {
    opacity: 1;
    height: 50px;
  }
  .pb-tabs__header {
    background: #fff;
    padding: 8px 16px 0;
    margin-bottom: 0;
    display: none; // 设计变更：仅展示全部，直接隐藏
  }
  .pb-tabs__content {
    padding: 16px 16px 8px;
    height: 100%;
  }
}
</style>
